import { AnyAction } from 'redux';
import { call, put, takeEvery } from 'redux-saga/effects';
import { AssessmentSummaryPayload } from 'types/assessment-payload';
import { getAssessmentSummary } from 'api/api';
import {
  fetchAssessmentSummaryErrorAction,
  fetchAssSummaryStartAction,
  fetchAssessmentSummarySuccessAction,
} from 'actions/assessmentSummary';
import { GET_ASSESSMENT_SUMMARY } from 'actions/assessmentSummary/types';

export function* fetchAssessmentSummary({ token }: AnyAction) {
  try {
    yield put(fetchAssSummaryStartAction());

    const { data: summary }: { data: AssessmentSummaryPayload } = yield call(
      getAssessmentSummary,
      token
    );

    yield put(fetchAssessmentSummarySuccessAction(summary));
  } catch (e) {
    yield put(
      fetchAssessmentSummaryErrorAction(
        e.response.data?.message,
        e.response.status
      )
    );
  }
}

export default function* watchFetchAssessmentSummary() {
  yield takeEvery(GET_ASSESSMENT_SUMMARY, fetchAssessmentSummary);
}
